import { display1TypographyMixin, display2TypographyMixin, display3TypographyMixin, display4TypographyMixin, display5TypographyMixin, display6TypographyMixin, display7TypographyMixin, display8TypographyMixin, textLinkTypographyMixin, tagTypographyMixin, eyebrowTypographyMixin, labelTypographyMixin, body1TypographyMixin, body2TypographyMixin, body3TypographyMixin, body4TypographyMixin, body5TypographyMixin, display9TypographyMixin, ctaTypographyMixin, } from "../mixins/typography";
import { SkinId } from "../../types";
import { link, media, accordionPlus, accordionMinus, dropdown, search, close, platformWindows, platformMac, platformIos, platformAndroid, platformPC, platformPSN, platformXbox, mediaSquare, linkSquare, playerSquare, discord, facebook, instagram, share, twitch, vk, youtube, line, x, reddit, rhombus, volumeUp, volumeDown, pause, play, linkUrl, checkmark, playstation, xbox, roleAssassin, roleController, roleDuelist, roleFighter, roleInitiator, roleMage, roleMarksman, roleSentinel, roleSupport, roleTank, difficultyLow, difficultyHigh, difficultyMed, plus, download, downloadSquare, marqueeArrowRight, divider, square, } from "../../common/icons";
import arrowLeft from "../assets/arrow-left.svg";
import arrowRight from "../assets/arrow-right.svg";
import carouselLeft from "../assets/carousel-left.svg";
import carouselRight from "../assets/carousel-right.svg";
import playerContrast from "../assets/player-contrast.svg";
import { mediaQueries } from "../../shared/mixins/breakpoints";
import { DEFAULT_BREAKPOINTS } from "../../../functional/breakpointUtils";
import tint from "polished/lib/color/tint";
import shade from "polished/lib/color/shade";
import { defaultSpacers } from "../../shared/spacers";
const RIOT_BAR_Z_INDEX = 200000;
const DROPDOWN_Z_INDEX = 300000;
export const rgProductBaseIcons = {
    link,
    media,
    accordionPlus,
    accordionMinus,
    dropdown,
    search,
    close,
    platformWindows,
    platformMac,
    platformIos,
    platformAndroid,
    platformPC,
    platformPSN,
    platformXbox,
    player: playerContrast,
    carouselLeft: carouselLeft,
    carouselRight: carouselRight,
    arrowRight: arrowRight,
    arrowLeft: arrowLeft,
    mediaSquare,
    linkSquare,
    playerSquare,
    discord,
    facebook,
    instagram,
    share,
    twitch,
    vk,
    youtube,
    line,
    x,
    reddit,
    rhombus,
    volumeUp,
    volumeDown,
    pause,
    play,
    linkUrl,
    checkmark,
    playstation,
    xbox,
    roleAssassin,
    roleController,
    roleDuelist,
    roleFighter,
    roleInitiator,
    roleMage,
    roleMarksman,
    roleSentinel,
    roleSupport,
    roleTank,
    difficultyLow,
    difficultyMed,
    difficultyHigh,
    plus,
    download,
    downloadSquare,
    marqueeArrowRight,
    divider,
    square,
};
const brandColors = {
    primary: "#EB0029",
    secondary: "#4500D5",
    dark1: "#0A1428",
    light1: "#FFFFFF",
    notDefined: "#FF00FF",
};
const palette1 = {
    accents1: brandColors.primary,
    accents1_hover: tint(0.2, brandColors.primary),
    accents1_disabled: tint(0.8, brandColors.dark1),
    accents2: brandColors.secondary,
    accents2_hover: tint(0.2, brandColors.secondary),
    accents2_disabled: tint(0.8, brandColors.dark1),
    bladetext1: brandColors.dark1,
    bladetext1_light: tint(0.4, brandColors.dark1),
    bladebg1: brandColors.light1,
    bladetext2: brandColors.primary,
    bladebg2: shade(0.2, brandColors.light1),
    bladetext3: brandColors.light1,
    bladebg3: brandColors.dark1,
    bladebg3_hover: tint(0.2, brandColors.dark1),
    bladebg3_disabled: shade(0.2, brandColors.dark1),
    bladetext_ulc: brandColors.light1,
    underlay: brandColors.dark1,
    keyline: shade(0.2, brandColors.light1),
    ctatext1: brandColors.dark1,
    ctatext1_hover: brandColors.dark1,
    ctatext1_disabled: tint(0.6, brandColors.dark1),
    ctabg1: brandColors.primary,
    ctabg1_hover: tint(0.2, brandColors.primary),
    ctabg1_disabled: tint(0.9, brandColors.dark1),
    ctatext2: brandColors.dark1,
    ctatext2_hover: brandColors.dark1,
    ctatext2_disabled: tint(0.6, brandColors.dark1),
    ctabg2: brandColors.secondary,
    ctabg2_hover: tint(0.2, brandColors.secondary),
    ctabg2_disabled: tint(0.9, brandColors.dark1),
    ctastroke1: brandColors.notDefined,
    ctastroke1_hover: brandColors.notDefined,
    ctastroke1_disabled: brandColors.notDefined,
    ctastroke2: brandColors.notDefined,
    ctastroke2_hover: brandColors.notDefined,
    ctastroke2_disabled: brandColors.notDefined,
};
const palette2 = {
    accents1: brandColors.primary,
    accents1_hover: tint(0.2, brandColors.primary),
    accents1_disabled: tint(0.2, brandColors.dark1),
    accents2: brandColors.secondary,
    accents2_hover: tint(0.2, brandColors.secondary),
    accents2_disabled: tint(0.2, brandColors.dark1),
    bladetext1: brandColors.light1,
    bladetext1_light: shade(0.4, brandColors.light1),
    bladebg1: brandColors.dark1,
    bladetext2: brandColors.primary,
    bladebg2: tint(0.2, brandColors.dark1),
    bladetext3: brandColors.dark1,
    bladebg3: brandColors.light1,
    bladebg3_hover: shade(0.2, brandColors.light1),
    bladebg3_disabled: shade(0.2, brandColors.light1),
    bladetext_ulc: brandColors.light1,
    underlay: brandColors.dark1,
    keyline: tint(0.2, brandColors.dark1),
    ctatext1: brandColors.dark1,
    ctatext1_hover: brandColors.dark1,
    ctatext1_disabled: tint(0.2, brandColors.dark1),
    ctabg1: brandColors.primary,
    ctabg1_hover: tint(0.2, brandColors.primary),
    ctabg1_disabled: tint(0.1, brandColors.dark1),
    ctatext2: brandColors.dark1,
    ctatext2_hover: brandColors.dark1,
    ctatext2_disabled: tint(0.2, brandColors.dark1),
    ctabg2: brandColors.secondary,
    ctabg2_hover: tint(0.2, brandColors.secondary),
    ctabg2_disabled: tint(0.1, brandColors.dark1),
    ctastroke1: brandColors.notDefined,
    ctastroke1_hover: brandColors.notDefined,
    ctastroke1_disabled: brandColors.notDefined,
    ctastroke2: brandColors.notDefined,
    ctastroke2_hover: brandColors.notDefined,
    ctastroke2_disabled: brandColors.notDefined,
};
const palette3 = {
    accents1: brandColors.light1,
    accents1_hover: tint(0.2, brandColors.light1),
    accents1_disabled: shade(0.2, brandColors.primary),
    accents2: brandColors.secondary,
    accents2_hover: tint(0.2, brandColors.secondary),
    accents2_disabled: shade(0.2, brandColors.primary),
    bladetext1: brandColors.dark1,
    bladetext1_light: tint(0.1, brandColors.dark1),
    bladebg1: brandColors.primary,
    bladetext2: brandColors.light1,
    bladebg2: shade(0.2, brandColors.primary),
    bladetext3: brandColors.light1,
    bladebg3: brandColors.dark1,
    bladebg3_hover: tint(0.2, brandColors.dark1),
    bladebg3_disabled: shade(0.2, brandColors.dark1),
    bladetext_ulc: brandColors.light1,
    underlay: brandColors.dark1,
    keyline: shade(0.2, brandColors.primary),
    ctatext1: brandColors.dark1,
    ctatext1_hover: brandColors.light1,
    ctatext1_disabled: shade(0.2, brandColors.primary),
    ctabg1: brandColors.light1,
    ctabg1_hover: brandColors.dark1,
    ctabg1_disabled: tint(0.2, brandColors.primary),
    ctatext2: brandColors.light1,
    ctatext2_hover: brandColors.dark1,
    ctatext2_disabled: shade(0.2, brandColors.primary),
    ctabg2: brandColors.dark1,
    ctabg2_hover: brandColors.light1,
    ctabg2_disabled: tint(0.2, brandColors.primary),
    ctastroke1: brandColors.notDefined,
    ctastroke1_hover: brandColors.notDefined,
    ctastroke1_disabled: brandColors.notDefined,
    ctastroke2: brandColors.notDefined,
    ctastroke2_hover: brandColors.notDefined,
    ctastroke2_disabled: brandColors.notDefined,
};
export const rgProductsBaseTheme = {
    skinId: SkinId.RiotProduct,
    palettes: {
        palette1,
        palette2,
        palette3,
    },
    palette: {
        primary: "#EB0029",
        secondary: "#4500D5",
        tertiary: "#FF9E00",
        quaternary: "#0BCFCB",
        background: "#fff",
        foreground: "#050505",
        secondaryBackground: "#0F1923",
        secondaryForeground: "#ECE8E1",
        tertiaryBackground: "#DAD7D0",
        tertiaryForeground: "#5F5F5F",
        error: "#ff0000",
        focus: "#EB0029",
    },
    DEFAULT_BREAKPOINTS,
    mediaQueries,
    spacers: defaultSpacers,
    dimensions: {
        pageWidth: DEFAULT_BREAKPOINTS.desktop,
        riotbarHeight: "80px",
        lightboxZIndex: RIOT_BAR_Z_INDEX,
        dropdownZIndex: DROPDOWN_Z_INDEX,
    },
    cssImports: [
        "https://lolstatic-a.akamaihd.net/webfonts/live/css/fonts/riotsans.css",
        "https://lolstatic-a.akamaihd.net/webfonts/live/css/fonts/inter.css",
        "https://lolstatic-a.akamaihd.net/webfonts/live/css/fonts/notosans.css",
    ],
    typography: {
        body1: body1TypographyMixin,
        body2: body2TypographyMixin,
        body3: body3TypographyMixin,
        body4: body4TypographyMixin,
        body5: body5TypographyMixin,
        tag: tagTypographyMixin,
        eyebrow: eyebrowTypographyMixin,
        label: labelTypographyMixin,
        textLink: textLinkTypographyMixin,
        display1: display1TypographyMixin,
        display2: display2TypographyMixin,
        display3: display3TypographyMixin,
        display4: display4TypographyMixin,
        display5: display5TypographyMixin,
        display6: display6TypographyMixin,
        display7: display7TypographyMixin,
        display8: display8TypographyMixin,
        display9: display9TypographyMixin,
        cta: ctaTypographyMixin,
    },
    input: {
        background: "#F0F0F0",
        border: "#141414",
        foreground: "#141414",
        backgroundFocus: "#FFF",
        borderFocus: "#000",
        foregroundFocus: "#000",
        backgroundChecked: "#F0F0F0",
        borderChecked: "#141414",
        foregroundChecked: "#141414",
        backgroundDisabled: "#D8D8D8",
        borderDisabled: "#A9A9A9",
        foregroundDisabled: "#A9A9A9",
        backgroundValid: "#F0F0F0",
        borderValid: "#141414",
        foregroundValid: "#141414",
        backgroundInvalid: "#FFE6FF",
        borderInvalid: "#EB0029",
        foregroundInvalid: "#000",
        placeholder: "#898989",
    },
    components: {
        ctaBackground: "#EB0029",
        ctaForeground: "#fff",
        uiBackground: "#EB0029",
        uiForeground: "#fff",
        uiBackgroundHover: "#fff",
        uiForegroundHover: "#EB0029",
        uiBackgroundActive: "#EB0029",
        uiForegroundActive: "#fff",
        uiBackgroundDisabled: "#D8D8D8",
        uiForegroundDisabled: "#A9A9A9",
    },
    icons: rgProductBaseIcons,
};
//# sourceMappingURL=base.js.map